import React, { useCallback, useRef, useState } from 'react';
import classNames from 'classnames';
import { memoize } from 'lodash';
import { useTranslation } from 'react-i18next';

import DropdownItem from './DropdownItem';
import ToolbarButton from '../ToolbarButton';
import Overlay, { useOverlayConfig } from '../../Overlay';

import { MoreIcon } from '@seismic/icons';

import './styles.scss';

const ToolbarDropdown = props => {
  const { t } = useTranslation();

  const [showDropdown, setShowDropdown] = useState(false);
  const buttonRef = useRef();
  const dropdownItems = React.Children.toArray(props.children);
  const hasMultipleItems = props.multipleMode || dropdownItems.length > 1;

  const closeDropdown = useCallback(() => setShowDropdown(false), []);
  const toggleDropdown = useCallback(() => setShowDropdown(!showDropdown), [showDropdown]);

  const onItemAction = memoize(action => (...args) => {
    action(...args);
    closeDropdown();
  });

  const singleItem = dropdownItems[0] && (
    <ToolbarButton
      icon={dropdownItems[0].props.icon}
      action={dropdownItems[0].props.action}
      disabled={dropdownItems[0].props.disabled}
    />
  );

  const overlayConfig = useOverlayConfig(
    {
      closeOnBackdropClick: true,
      onClose: closeDropdown,
      origin: buttonRef,
      ...props.overlayConfig
    },
    [props.overlayConfig]
  );

  const multipleItems = (
    <div>
      <ToolbarButton
        className="up-dropdown-button"
        icon={<MoreIcon />}
        disabled={props.disabled}
        action={toggleDropdown}
        ref={buttonRef}
        aria-label={
          showDropdown
            ? t('AnnotationCommentDialog.DropdownMenu.Close', {
                defaultValue: 'Close dropdown'
              })
            : t('AnnotationCommentDialog.DropdownMenu.Open', {
                defaultValue: 'Open dropdown'
              })
        }
      />
      {showDropdown && (
        <Overlay {...overlayConfig}>
          <div className={`up-dropdown-content up-dropdown-${props.position} ${showDropdown ? 'up-show' : 'up-hide'}`}>
            {dropdownItems.map(item => {
              return React.cloneElement(item, {
                action: onItemAction(item.props.action)
              });
            })}
          </div>
        </Overlay>
      )}
    </div>
  );

  const classes = classNames({
    'up-toolbar-dropdown-container': true,
    'up-multiple': hasMultipleItems,
    disabled: props.disabled
  });

  return <div className={classes}>{hasMultipleItems ? multipleItems : singleItem}</div>;
};

export { ToolbarDropdown, DropdownItem };
